import React from "react";
import { useT } from "@/i18n/LanguageContext";

export default function LanguageToggle({ compact = false }) {
  const { lang, setLang } = useT();
  return (
    <div
      data-testid="language-toggle"
      role="group"
      aria-label="Language toggle"
      className={`inline-flex items-center rounded-full border border-[var(--border)] bg-[var(--surface)] p-0.5 ${
        compact ? "text-[10px]" : "text-[11px]"
      }`}
    >
      <button
        data-testid="lang-en"
        onClick={() => setLang("en")}
        aria-pressed={lang === "en"}
        className={`px-2.5 py-1 rounded-full uppercase tracking-[0.18em] transition-colors ${
          lang === "en"
            ? "bg-[var(--primary)] text-[var(--bg)]"
            : "text-[var(--text-muted)] hover:text-[var(--primary)]"
        }`}
      >
        EN
      </button>
      <button
        data-testid="lang-es"
        onClick={() => setLang("es")}
        aria-pressed={lang === "es"}
        className={`px-2.5 py-1 rounded-full uppercase tracking-[0.18em] transition-colors ${
          lang === "es"
            ? "bg-[var(--primary)] text-[var(--bg)]"
            : "text-[var(--text-muted)] hover:text-[var(--primary)]"
        }`}
      >
        ES
      </button>
    </div>
  );
}
